export default function numberHumanizer(
  number: number | string | null | undefined
): string {
  try {
    const strippedNumber = number?.toString()?.replace(/,/g, '');
    const formatted = strippedNumber?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return formatted === '' || formatted === ',' ? '' : (formatted ?? '');
  } catch (error) {
    console.error('ERROR PARSING NUMBER', error);
    return number?.toString() ?? '';
  }
}
